import React, { Component } from "react";
import "antd/dist/antd.min.css";
import { Row, Col, Button, Card } from "antd";
import AppConfig from "../config/AppConfig";
import { getQuestion } from "../../Api/Apis";
import Loading from "../Leads/Loading";
// import { Link } from "react-router-dom";
export default class Myleads extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: [],
      List: ["9"],
      selectedRowKeys: [],
      companies: [],
      loading: false,
      matchingData: {},
    };
  }
  componentDidMount = () => {
    let id = JSON.parse(localStorage.getItem("leadId"));
    getQuestion(AppConfig["entityNames"]["getQuestion"], id).then((result) => {
      if (result.data) {
        this.saveCompaniesData(result.data);
      } else {
        alert("No matchingData");
      }
      // this.setState({
      //   loading:true,
      // })
      // console.log(this.state.matchingData,"matchhh")
    });

    this.saveCompaniesData = async (user) => {
      // console.log(data)
      this.setState({
        companies: user,
      });

      this.setState({
        loading: false,
      });
    };
  };
  handleTogetmoreInfo = (recordId) => {
    let id = JSON.parse(localStorage.getItem("leadId"));
    let companiesdata = this.state.companies;
    let getInfoCompany = companiesdata.filter((o) => o.id === recordId);
    const payload = getInfoCompany.length ? getInfoCompany[0] : null;
  this.props.history.push(`/app/Leadscontact/${recordId}`, payload);
  };
  handleAvailable = (recordId) => {
    let id = JSON.parse(localStorage.getItem("leadId"));
    let companiesdata = this.state.companies;
    let getInfoCompany = companiesdata.filter((o) => o.id === recordId);
    const company = getInfoCompany.length ? getInfoCompany[0] : null;
  if (company && company.paymentIds && Array.isArray(company.paymentIds) && company.paymentIds.includes(id)) {
    this.props.history.push(`/app/Leadscontact/${recordId}`, company);
  } else {
    this.props.history.push(`/app/Leadscontact/${recordId}`, company);
  }
  };

  render() {
  const companiesdata = this.state.companies || [];
  const id = JSON.parse(localStorage.getItem("leadId"));
  const newLeads = companiesdata.filter(
    (d) => !d.paymentIds || !Array.isArray(d.paymentIds) || !d.paymentIds.includes(id)
  );
  const availableLeads = companiesdata.filter(
    (d) => Array.isArray(d.paymentIds) && d.paymentIds.includes(id)
  );

  const renderCard = (data, onClickHandler) => (
    <Col span={20} offset={2} key={data.id}>
      <Card className="ant-card-body" style={{ marginBottom: "2vw", borderRadius: "10px" }}>
        <Row>
          <Col xxl={{ span: 8 }} xl={{ span: 8 }} lg={{ span: 8 }} md={{ span: 8 }} sm={{ span: 24 }} xs={{ span: 24 }}>
            <span style={{ fontSize: "11px" }}>Looking For</span>
            <Row>
              {Array.isArray(data.service) &&
                data.service.map((style, idx) => (
                  <Button key={idx} style={{ backgroundColor: "#9baebc", color: "white", fontSize: "10px", border: "none", marginRight: "5px", marginBottom: "10px" }}>
                    {style}
                  </Button>
                ))}
            </Row>
          </Col>

          <Col xxl={{ span: 12 }} xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
            <Row>
              <Col span={12}>
                <span style={{ fontSize: "11px" }}>INDUSTRY</span>
                <h4><b>{Array.isArray(data.industry) ? data.industry.join(", ") : data.industry}</b></h4>
              </Col>
              <Col span={12}>
                <span style={{ fontSize: "11px" }}>BUDGET</span>
                <h4><b>{data.rangeGoals}</b></h4>
              </Col>
            </Row>
          </Col>

          <Col xxl={{ span: 4 }} xl={{ span: 4 }} lg={{ span: 4 }} md={{ span: 4 }} sm={{ span: 24 }} xs={{ span: 24 }}>
            <Button type="primary" style={{ borderRadius: "50px", backgroundColor: "#165874", width: "200px" }} onClick={() => onClickHandler(data.id)}>
              Get More Information
            </Button>
          </Col>
        </Row>
      </Card>
    </Col>
  );

  // If there are no leads at all show a single global message
  if (newLeads.length === 0 && availableLeads.length === 0) {
    return (
      <div>
        <Loading enableLoading={this.state.loading} />
        <div style={{ marginTop: "3vw" }}>
          <Col span={20} offset={2}>
            <h1><b>New Leads</b></h1>
          </Col>
        </div>

        <div style={{ marginTop: "3vw" }}>
          <Col span={20} offset={2}>
            <Card style={{ borderRadius: 10, textAlign: "center" }}>
              <h3 style={{ margin: 0 }}>No leads to show</h3>
              <p style={{ margin: 0 }}>There are no new leads and no available leads for your account right now.</p>
            </Card>
          </Col>
        </div>
      </div>
    );
  }

  // Otherwise render each section with its own heading (and only show per-section messages when that section is empty)
  return (
    <div>
      <Loading enableLoading={this.state.loading} />

      <div style={{ marginTop: "3vw" }}>
        <Col span={20} offset={2}>
          <h1><b>New Leads</b></h1>
        </Col>
      </div>

      {newLeads.length > 0 ? newLeads.map((d) => renderCard(d, this.handleTogetmoreInfo)) : (
        <Col span={20} offset={2} style={{ marginBottom: "2vw" }}>
          <Card style={{ borderRadius: 10, textAlign: "center" }}>
            <h3 style={{ margin: 0 }}>No new leads are available right now.</h3>
            <p style={{ margin: 0 }}>We'll notify you when new leads match your profile.</p>
          </Card>
        </Col>
      )}

      <div style={{ marginTop: "3vw" }}>
        <Col span={10} offset={2}>
          <h1><b>Available Leads</b></h1>
        </Col>
      </div>

      {availableLeads.length > 0 ? availableLeads.map((d) => renderCard(d, this.handleAvailable)) : (
        <Col span={20} offset={2} style={{ marginBottom: "2vw" }}>
          <Card style={{ borderRadius: 10, textAlign: "center" }}>
            <h3 style={{ margin: 0 }}>No available leads yet.</h3>
            <p style={{ margin: 0 }}>You haven't purchased any leads. Check back later.</p>
          </Card>
        </Col>
      )}
    </div>
  );
}

}
